import React from 'react'
import HousekeepingHero from './HousekeepingHero'
import HousekeepingContent from './HousekeepingContent'
import HousekeepingServices from './HousekeepingServices'
import HouseingTrustSection from './HouseingTrustsection'
import HouseingTransform from './HouseingTransform'
import Footer from '../Footer/Footer'

function HouseCorporate() {
    return (
        <div>
            <HousekeepingHero/>
            <HousekeepingContent/>
            <HousekeepingServices/>
            <HouseingTrustSection/>
            <HouseingTransform/>
            <Footer/>
            
        </div>
    )
}

export default HouseCorporate
